module.exports = __webpack_public_path__ + "media/images/feedback-50c5fef427b4f72e5ac5aefacc81974e.png";